function autobind(originalMethod, context) {
  const methodName = context.name;
  if (context.private) {
    throw new Error(`'autobind' cannot decorate private properties like ${methodName}.`);
  }
  context.addInitializer(function () {
    // @ts-expect-error - this is a decorator
    // eslint-disable-next-line
    this[methodName] = this[methodName].bind(this);
  });
}
export default autobind;